import { FixtureTickerCard } from './FixtureTickerCard';
import { clampTickerCount } from '@lib/article-blocks/registry';
import { buildFixtureRange, sortTickerRows } from '@lib/article-blocks/ticker';
import type { TickerRow } from '@lib/article-blocks/ticker';
import type {
  ArticleBlockData,
  SanityFixtureTickerBlock
} from '@lib/article-blocks/types';
import { GAMEWEEK_ONE } from '@lib/constants';

const DEFAULT_SORT = 'difficulty';

type FixtureTickerBlockProps = {
  value: SanityFixtureTickerBlock;
  data: ArticleBlockData;
};

export const FixtureTickerBlock = ({
  value,
  data
}: FixtureTickerBlockProps) => {
  const allShortNames = Object.keys(data.fixturesByTeamShortName);
  const selected =
    value.teams && value.teams.length > 0 ? value.teams : allShortNames;
  const startGameweek =
    value.startGameweek ?? Math.max(GAMEWEEK_ONE, data.currentGameweek + 1);
  const count = clampTickerCount(value.gameweekCount);

  const rows: TickerRow[] = selected
    .filter((shortName) => shortName in data.fixturesByTeamShortName)
    .map((shortName) => ({
      shortName,
      name: data.teamNamesByShortName[shortName] ?? shortName,
      gameweeks: buildFixtureRange(
        data.fixturesByTeamShortName[shortName],
        startGameweek,
        count
      )
    }));
  if (rows.length === 0) return null;

  const sorted = sortTickerRows(rows, value.sortBy ?? DEFAULT_SORT);
  return (
    <FixtureTickerCard
      rows={sorted}
      gameweeks={sorted[0].gameweeks.map((entry) => entry.gameweek)}
    />
  );
};
